import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OpcionesService, PanelItemOpcionesVM } from '../../infrastructure/services/opciones.service';
import { AlertService, GrowlType } from '../../infrastructure/services/alert.service';

@Component({
  templateUrl: 'seleccionar.tipo.asset.component.html'
})
export class SeleccionarTipoAssetComponent implements OnInit {
  constructor() { }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/assets/seleccionar.tipo.asset.component.ts